/**
 * Resolve the post-login landing path for a given user.
 *
 * Users can pick a preferred landing page in their profile
 * (`default_landing_page`). This helper honours that preference, with
 * role-based fallbacks so the redirect never dumps a repro partner or a
 * customer onto an admin-only route.
 *
 * Used by:
 *  - LoginPage after a successful email/password submit.
 *  - PublicRoute when an already-authenticated user hits `/login`.
 */
export const resolveLandingPath = (user) => {
    const role = user?.role;
    const isAdmin = role === 'admin' || role === 'super_admin';

    // Fixed routing for restricted roles — preferences don't apply.
    if (role === 'repro_partner') return '/artwork-jobs';
    if (role === 'guest') return '/dashboard';

    const pref = user?.default_landing_page;
    if (pref === 'overview') return isAdmin ? '/admin/overview' : '/dashboard';
    if (pref === 'artwork-jobs') return '/artwork-jobs';
    if (pref === 'finance') return isAdmin ? '/finance/invoices' : '/invoices';
    if (pref === 'orders') return '/dashboard';

    // No preference set — previous default.
    return '/dashboard';
};
